<template>
  <b-modal
    id="movetoni"
    centered
    hide-footer
    hide-header
    no-close-on-backdrop
    :visible="isNotInterested"
    @hidden="$emit('close-modal')"
  >
    <div class="w-100">
      <div class="p-3 d-flex justify-content-between align-items-center">
        <div class="pff-modal-heading">
          <span class="mr-1"
            ><img src="../../../assets/img/newkanban/mainni.svg" alt=""
          /></span>
          Move to Not Interested
        </div>
        <div class="pointer" @click="$emit('close-modal')">
          <img
            class="rotate-on-hover"
            src="../../../assets/img/feedbackform/x-close.svg"
            alt=""
          />
        </div>
      </div>
    </div>
    <hr class="m-0" />
    <div class="p-3">
      <div class="kanban-ni-subheads mt-1">
        Are you sure you want to move this candidate to Not Interested?
      </div>
      <div
        class="schedint-panelist-info-container d-flex align-items-center mt-3"
      >
        <div class="w-10 text-center">
          <div
            v-if="
              selectedCandidate.customFields &&
              selectedCandidate.customFields.imageMedia &&
              selectedCandidate.customFields.imageMedia != null
            "
            class="kanban-maincard-dp"
          >
            <img
              class="w-100 h-100"
              :src="selectedCandidate.customFields.imageMedia"
              alt=""
            />
          </div>

          <div
            class="
              kanban-maincard-dp-text
              d-flex
              justify-content-center
              align-items-center
            "
            v-else
          >
            {{ selectedCandidate.name[0].toUpperCase() }}
          </div>
        </div>
        <div class="w-40 text-truncate">{{ selectedCandidate.name }}</div>
        <div class="w-50 text-truncate">{{ selectedCandidate.email }}</div>

        <!-- <div
          class="w-10 ml-2 text-center pointer"
          @click="$emit('view-candidate')"
        >
          <img src="../../../assets/img/newkanban/tabview.svg" alt="" />
        </div> -->
      </div>
      <div class="newmodalinputbox mt-3">
        <div class="jdk-ip-confirm-subtxt">
          Remarks<span class="asterik">*</span>
        </div>
        <b-form-textarea
          style="overflow-y: auto"
          rows="2"
          type="text"
          max-rows="5"
          placeholder="Enter"
          v-model.trim="$v.remarks.$model"
          :class="$v.remarks.$error ? 'error' : ''"
        >
        </b-form-textarea>
        <div
          v-if="$v.remarks.$dirty && !$v.remarks.required"
          class="errortxt position-absolute"
        >
          Required
        </div>
        <div
          v-else-if="!$v.remarks.maxLength"
          class="errortxt position-absolute"
        >
          Exceeded the max char length of 256
        </div>
      </div>
    </div>

    <div
      class="
        d-flex
        align-items-center
        justify-content-end
        p-2
        bluebtn
        mt-2
        mb-2
      "
    >
      <b-button
        class="acs-cancelBtn-modal w-105px mr-3"
        @click="$emit('close-modal')"
        >Cancel</b-button
      >
      <div class="position-relative">
        <b-button
          class="acs-addBtn-modal w-105px"
          :class="showLoader ? 'confirm-loader-class defaultCursor' : 'pointer'"
          @click="showLoader ? '' : confirm()"
          >{{ showLoader ? "" : "Confirm" }}</b-button
        >
        <div v-if="showLoader" class="confirm-loader-pos">
          <Loader />
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { required, maxLength } from "vuelidate/lib/validators";
import { notInterestedCandidate } from "../../../utils/apiFunctions";
import Loader from "../../fixedcomponents/Loader.vue";
import toast from "../../mixin/toast";
export default {
  data() {
    return {
      remarks: "",
      showLoader: false,
    };
  },
  mixins: [toast],
  props: {
    isNotInterested: Boolean,
    selectedCandidate: Object,
    particularJob: Object,
  },
  components: {
    Loader,
  },
  validations: {
    // return{
    remarks: {
      required,
      maxLength: maxLength(256),
    },
    // }
  },
  created() {},
  methods: {
    async confirm() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.showLoader = true;
        let payload = {
          candidateID: this.selectedCandidate.candidateID,
          customerID: this.particularJob.customerID,
          jobID: this.particularJob.jobID,
          recommendation: "NI",
          remarks: this.remarks,
        };
        if (this.$route.name == "VendorKanban") {
          payload.vendorID = this.$route.params.vendorID;
        }
        const res = await notInterestedCandidate(payload);
        if (res.status == 200) {
          this.showLoader = false;
          this.$emit("close-modal");
          this.$emit("update-details");
          this.$nextTick(() => {
            let value = "Moved to Not-Interested";
            var text = `Candidate "${this.selectedCandidate.name}" has been moved to not-interested`;
            this.dynamicToast("notinterested", `Successfully ${value}`, text);
          });
        }
      }
    },
  },
};
</script>

<style></style>
